const LS_KEY_EMAIL = 'pertrain.auth.email.v1';

// Change this email to the one that should have editor access
export const EDITOR_EMAIL = 'editor@pertrain.local';

export function setEmail(email: string) {
  if (typeof window === 'undefined') return;
  localStorage.setItem(LS_KEY_EMAIL, email);
}

export function getEmail(): string {
  if (typeof window === 'undefined') return '';
  return localStorage.getItem(LS_KEY_EMAIL) || '';
}

export function clearEmail() {
  if (typeof window === 'undefined') return;
  localStorage.removeItem(LS_KEY_EMAIL);
}

export function isEditor(email: string): boolean {
  return !!email && email.toLowerCase() === EDITOR_EMAIL.toLowerCase();
}
